import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf, NgStyle } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'mrs-btn-primary',
    templateUrl: './mrs-btn-primary.component.html',
    styleUrls: ['./mrs-btn-primary.component.scss'],
    imports: [NgIf, MatButtonModule, NgStyle]
})
export class MrsBtnPrimaryComponent {
    @Input() buttonLabel: string;
    @Input() buttonId: string;
    @Input() isSubmitButton = false;
    @Input() disabled = false;
    @Input() iconName: string;
    @Input() iconPosition = 'before';
    @Output() onClick = new EventEmitter<Event>();

    textColor: string = 'white'; // Default text color for primary button
}
